// extracted by mini-css-extract-plugin
export var active = "_1p-7";
export var container = "_1p-0";
export var evenWidth = "_1p-4";
export var large = "_1p-5";
export var outlet = "_1p-8";
export var slide = "_1p-2";
export var small = "_1p-6";
export var tab = "_1p-3";
export var tabs = "_1p-1";